import React from 'react';
import PropTypes from 'prop-types';
import AddRadiostationForm from './AddRadiostationForm';
import FloatingPanel from '../../../../components/Panel/FloatingPanel';
import { getPhotoCurrentUser } from '../../../../service/s3Amplify';

class AddRadiostation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      img: '',
      files: [],
      urlPreview:'',
      imgError:''
    };
    this.onDrop = this.onDrop.bind(this);
  }
  componentWillReceiveProps(newProps){
    if(newProps.dataInit !== null){
      getPhotoCurrentUser(newProps.dataInit.radiostation_photo).then(response =>{
        this.setState({
          urlPreview:response
        });
      }).catch(err =>{
        console.log("error url", err);
      });
    }else{
      this.setState({
        img:''
      });
    }
  }

  onDrop(files) {
    if (files.length>0) {
      this.setState({ img: files[0] ,imgError:'' });
    } else {      
      this.setState({imgError:'Archivo Inválido'})
    }
  }

  cleanValues = () => { 
    setTimeout(() => {
      this.props.closeForm();
      this.setState({ img: '',urlPreview:'',files: [] });
    }, 500);
  }
  render() {
    const { 
      openForm,
      dataInit,
      submit
    } = this.props;
    const branch = '';
    return (
      <div>
        <FloatingPanel title="Radiodifusora" openForm={openForm} branch={branch} closeForm={this.cleanValues}>
          <AddRadiostationForm
            onSubmit={()=>{}}
            onDrop={this.onDrop}
            imgAvatar={this.state.img ? this.state.img.preview : this.state.urlPreview}
            handleSubmit={(event, data)=>(submit(event, data,this.state.img),this.cleanValues())}
            dataInit={dataInit}
            isOpen={openForm}
            imgError={this.state.imgError}
          />
        </FloatingPanel>
      </div>
    );
  }
}

AddRadiostation.propTypes = {
  classes: PropTypes.object,
  submit: PropTypes.func,
  addRadiostation: PropTypes.func,
  openForm: PropTypes.bool,
  avatarInit: PropTypes.string,
  closeForm: PropTypes.func,
  dataInit:PropTypes.object
};

export default AddRadiostation;
